import { render, staticRenderFns } from "./HtDuration.vue?vue&type=template&id=b79b6fdc&"
import script from "./HtDuration.vue?vue&type=script&lang=js&"
export * from "./HtDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports